import styled from 'styled-components'

export const MedicalRecordFormTypeSelectContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  
  div {
    max-width: initial;
  }
`

export const TitleContainer = styled.div``

export const SelectLegendContainer = styled.div`
  margin-top: 5px;

  p {
    color: #898989;
  }
`